import * as React from "react"

import { useStory } from "../context/story-context"

const Overlay = () => {
  // can also pull out auditScores from the story
  const { currentStoryItem, toggleTools } = useStory()
  const { overlay, overlayColor } = currentStoryItem

  if (overlay) {
    return (
      <div className="absolute top-0 right-0 h-full w-full z-10">
        <div className="w-full h-full flex flex-col items-center justify-center"></div>
      </div>
    )
  }
  return null
}

export default Overlay
